// src/pages/CompanyIntroPage.js
import React, { useRef, useEffect, useState, useCallback } from "react";
import HeroSection from "../components/HeroSection";
import CompanyVisionSection from "../components/CompanyVisionSection";
import "../styles/CompanyIntroPage.css"; // 전역 스타일 또는 페이지별 스타일

function CompanyIntroPage() {
  const sectionsRef = useRef([]);
  const [visibleSections, setVisibleSections] = useState({});

  const observerCallback = useCallback((entries) => {
    entries.forEach((entry) => {
      setVisibleSections((prev) => ({
        ...prev,
        [entry.target.id]: entry.isIntersecting,
      }));
    });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(observerCallback, {
      root: null, // viewport
      rootMargin: "0px",
      threshold: 0.5, // 50% 이상 보일 때
    });

    const currentSections = sectionsRef.current;
    currentSections.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      currentSections.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, [observerCallback]);

  return (
    <div className="company-intro-page">
      <section
        id="hero"
        ref={(el) => (sectionsRef.current[0] = el)}
        className={`section ${
          visibleSections["hero"] ? "fade-in" : "fade-out"
        }`}
      >
        <HeroSection />
      </section>

      <section
        id="company-vision"
        ref={(el) => (sectionsRef.current[1] = el)}
        className={`section ${
          visibleSections["company-vision"] ? "fade-in" : "fade-out"
        }`}
      >
        <CompanyVisionSection />
      </section>
    </div>
  );
}

export default CompanyIntroPage;
